import { Alert, Button, Snackbar } from "@mui/material";
import { GridApiCommunity } from "@mui/x-data-grid/models/api/gridApiCommunity";
import PreviewIcon from "@mui/icons-material/Preview";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export const CustomPreviewButton = ({
  apiRef,
}: {
  apiRef: React.RefObject<GridApiCommunity>;
}) => {
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handlePreview = () => {
    const selectedRows = Array.from(
      apiRef.current?.getSelectedRows()?.values() || []
    );

    if (selectedRows.length === 1) {
      const selectedUser = selectedRows[0];
      const userId = selectedUser.id; // Pass the user's ID

      // Navigate to the PDF viewer with the user ID
      navigate("/pdf-viewer", { state: { userId } });
    } else {
      setSnackbarOpen(true);
    }
  };

  return (
    <>
      <Button
        onClick={handlePreview}
        startIcon={<PreviewIcon />}
        variant="text"
        size="small"
        sx={{ textTransform: "none" }}
      >
        Preview
      </Button>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity="warning"
          onClose={() => setSnackbarOpen(false)}
          sx={{ width: "100%" }}
        >
          Please select exactly one user to preview.
        </Alert>
      </Snackbar>
    </>
  );
};
